// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1sOng","fileBtn":"File_fileBtn__2yPiV","closeBtn":"File_closeBtn__NQofb","fileSelected":"File_fileSelected__3S0M4","disabled":"File_disabled__21Tmc"};